import React from 'react';
import {
  HeartPulse, TrendingUp, Newspaper, Shirt, Scale, Church, Users, Cpu,
  GraduationCap, Leaf, X, Map,
} from 'lucide-react';
import { useStore } from '../store';
import { ZONES } from '../config/zones';

const ICONS = { HeartPulse, TrendingUp, Newspaper, Shirt, Scale, Church, Users, Cpu, GraduationCap, Leaf };

export function ZoneMenuButton() {
  const open = useStore((s) => s.zoneMenuOpen);
  const setOpen = useStore((s) => s.setZoneMenuOpen);
  return (
    <button
      data-testid="zone-menu-toggle"
      onClick={() => setOpen(!open)}
      className="flex items-center gap-2 px-4 py-2.5 glass-gold rounded-full text-gold hover:bg-gold hover:text-black transition-colors duration-300 uppercase tracking-widest text-[10px] font-bold pointer-events-auto"
    >
      <Map className="w-4 h-4" strokeWidth={1.6} />
      Zones
    </button>
  );
}

export default function ZoneMenu() {
  const open = useStore((s) => s.zoneMenuOpen);
  const setOpen = useStore((s) => s.setZoneMenuOpen);
  const goToZone = useStore((s) => s.goToZone);
  const currentZone = useStore((s) => s.currentZone);

  if (!open) return null;

  const jump = (i) => {
    goToZone(i);
    setOpen(false);
  };

  return (
    <div
      data-testid="zone-menu"
      className="absolute top-24 right-5 md:right-9 w-72 glass-gold p-5 z-[60] pointer-events-auto animate-hud-in gold-scroll"
      style={{ maxHeight: '70vh', overflowY: 'auto' }}
    >
      <div className="flex items-center justify-between mb-4">
        <span className="font-mono text-[10px] font-bold uppercase tracking-[0.3em] text-gold">Leap to a Zone</span>
        <button data-testid="zone-menu-close" onClick={() => setOpen(false)} className="text-white/50 hover:text-gold">
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="flex flex-col gap-1.5">
        {ZONES.map((z) => {
          const Icon = ICONS[z.icon] || Leaf;
          const active = z.index === currentZone;
          return (
            <button
              key={z.id}
              data-testid={`zone-jump-${z.id}`}
              onClick={() => jump(z.index)}
              className={`group flex items-center gap-3 px-3 py-2.5 border transition-colors duration-200 text-left ${
                active ? 'border-gold bg-gold/10 text-gold' : 'border-white/8 text-white/70 hover:border-gold/50 hover:text-gold'
              }`}
            >
              <span className="font-mono text-[10px] w-5 text-gold/70">{String(z.number).padStart(2, '0')}</span>
              <Icon className="w-4 h-4 shrink-0" strokeWidth={1.4} />
              <span className="font-serif text-base leading-tight">{z.title}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
